import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';

const WORKFORCE_PARAS = (
  <>
    <StyledParagraph $largeText>
      Set the ratio of full-time and part-time employees as well as the estimated number of work days each group has per
      year.
    </StyledParagraph>
    <StyledParagraph $largeText>
      These numbers will then be used alongside the employee commuting activity data you enter to calculate the
      estimated carbon emissions for each employee.
    </StyledParagraph>
  </>
);

const ACTIVITY_PARAS = (
  <StyledParagraph $largeText>
    Activity-based emissions are calculated using activity data — that is, the transport method (driving, by bus, by
    train, etc.) and estimated distance traveled — multiplied by industry-standard emission factors (which may be local,
    national, or market-based).
  </StyledParagraph>
);

export const BOTTOM_COMMUTES_ALL = (
  <div className="default-all">
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Inputting data for this category
    </StyledHeading>
    <StyledParagraph $largeText>
      To account for hybrid working patterns, you will need to enter in your workforce breakdown as well as your
      activity data.
    </StyledParagraph>
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Workforce breakdown
    </StyledHeading>
    {WORKFORCE_PARAS}
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Activity data
    </StyledHeading>
    {ACTIVITY_PARAS}
  </div>
);

export const BOTTOM_COMMUTES_WORKFORCE = (
  <div className="default-all">
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Inputting workforce breakdown
    </StyledHeading>
    {WORKFORCE_PARAS}
  </div>
);

export const BOTTOM_COMMUTES_ACTIVITY = (
  <div className="default-all">
    <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
      Inputting activity data
    </StyledHeading>
    {ACTIVITY_PARAS}
  </div>
);
